import { Controller } from "@hotwired/stimulus"
import { seemsOffline } from "utils/connectivity"
import { paintIllnessScriptProgressOffline } from "utils/illness_script_offline_progress"

const MODAL_STORAGE_KEYS = ["showModal", "lowTimeModal", "completionModal"]

export default class extends Controller {
  connect() {
    MODAL_STORAGE_KEYS.forEach((key) => localStorage.removeItem(key))

    this.repaintIllnessScriptOfflineProgress()

    this.boundAddBreadcrumbClass = this.addBreadcrumbClass.bind(this)
    this.addBreadcrumbClass()
    document.addEventListener("turbo:load", this.boundAddBreadcrumbClass)
  }

  repaintIllnessScriptOfflineProgress() {
    const { illnessScriptDocumentId } = this.element.dataset
    if (!illnessScriptDocumentId) return
    if (!seemsOffline()) return

    paintIllnessScriptProgressOffline({ documentId: illnessScriptDocumentId })
  }

  disconnect() {
    document.removeEventListener("turbo:load", this.boundAddBreadcrumbClass)
  }

  addBreadcrumbClass() {
    const breadcrumbContainer = document.querySelector(".sticky-info.breadcrumb-container")
    if (breadcrumbContainer) {
      breadcrumbContainer.classList.add("breadcrumb-with-progress-elements")
    }
  }

  linkButtonSpace(event) {
    if (event.key === " " || event.key === "Spacebar") {
      event.preventDefault()
      event.currentTarget.click()
    }
  }
}
